module.exports = __webpack_public_path__ + "pe.svg?5ddb3d5934f2955f157d44f7720d2bff";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/pe.svg
// module id = 1349
// module chunks = 27